module.exports = __webpack_public_path__ + "p3_img3.jpg?58f77aa845e65d922af6387e3b04d635";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p3/p3_img3.jpg
// module id = 177
// module chunks = 0